import { defineStore } from 'pinia';
import PermissionsService from '@/services/permissionsService';
import { useAuthStore } from './auth';

export const usePermissionsStore = defineStore('permissions', {
    state: () => ({
        permissions: [],
        loaded: false,
        loading: false,
        _fetchPromise: null,
    }),

    getters: {
        hasPermission: (state) => {
            return (permission) => {
                const authStore = useAuthStore();
                if (authStore.isAdmin) return true;
                if (!permission) return true;
                return state.permissions.includes(permission);
            };
        },

        hasAnyPermission: (state) => {
            return (permissions) => {
                const authStore = useAuthStore();
                if (authStore.isAdmin) return true;
                if (!permissions || permissions.length === 0) return true;
                return permissions.some(p => state.permissions.includes(p));
            };
        },

        hasAllPermissions: (state) => {
            return (permissions) => {
                const authStore = useAuthStore();
                if (authStore.isAdmin) return true;
                if (!permissions || permissions.length === 0) return true;
                return permissions.every(p => state.permissions.includes(p));
            };
        },
    },

    actions: {
        async fetchPermissions() {
            const authStore = useAuthStore();
            if (!authStore.isAuthenticated) return;

            if (this._fetchPromise) return this._fetchPromise;

            this.loading = true;
            this._fetchPromise = (async () => {
                try {
                    const response = await PermissionsService.getCurrentUserPermissions();
                    const data = response.data;
                    // Handle various API response formats
                    let perms = [];
                    if (Array.isArray(data)) {
                        perms = data;
                    } else if (data && typeof data === 'object') {
                        if (Array.isArray(data.data)) {
                            perms = data.data;
                        } else if (Array.isArray(data.permissions)) {
                            perms = data.permissions;
                        }
                    }
                    // Normalize: extract string values from permission objects
                    this.permissions = perms.map(p => typeof p === 'string' ? p : (p.value || p.name || p));
                    this.loaded = true;
                } catch (error) {
                    console.error('Erreur lors du chargement des permissions:', error);
                    this.permissions = [];
                } finally {
                    this.loading = false;
                    this._fetchPromise = null;
                }
            })();

            return this._fetchPromise;
        },

        clearPermissions() {
            this.permissions = [];
            this.loaded = false;
            this.loading = false;
        },
    }
});
